import { all, call, put, takeEvery } from 'redux-saga/effects';

import {
    FETCH_TRAINING_PLANS,
    FETCH_TRAINING_PLANS_FETCHING,
    FETCH_TRAINING_PLANS_SUCCESS,
    FETCH_TRAINING_PLANS_FAIL,
    FETCH_SELF_GUIDED_PLAN,
    FETCH_SELF_GUIDED_PLAN_FETCHING,
    FETCH_SELF_GUIDED_PLAN_SUCCESS,
    FETCH_SELF_GUIDED_PLAN_FAIL,
    FETCH_ALL_SELF_GUIDED_PLAN,
    FETCH_ALL_SELF_GUIDED_PLAN_FETCHING,
    FETCH_ALL_SELF_GUIDED_PLAN_SUCCESS,
    FETCH_ALL_SELF_GUIDED_PLAN_FAIL,
    FETCH_ACTIVE_PLANS,
    FETCH_ACTIVE_PLANS_FETCHING,
    FETCH_ACTIVE_PLANS_SUCCESS,
    FETCH_ACTIVE_PLANS_FAIL
} from 'actions/ActionTypes';

import { gcApi } from '../config/axios';

const toProperCase = (str) => {
    return str
        .split(' ')
        .map((w) => w[0].toUpperCase() + w.substring(1).toLowerCase())
        .join(' ');
};

export function* fetchTrainingPlans(action) {
    const { activityType, planType, start, limit, locale } = action;
    // API is case sensitive expects Running
    let apiActivityType = toProperCase(activityType);

    try {
        yield put({
            type: FETCH_TRAINING_PLANS_FETCHING,
            activityType
        });

        // Odd we have to use a POST instead of a GET
        const response = yield call(
            gcApi.post,
            `/trainingplan-service/trainingplan/search?start=${start}&limit=${limit}&locale=${locale}&types=${apiActivityType}${
                planType ? '&subTypes=' + planType : ''
            }`,
            {},
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );

        yield put({
            type: FETCH_TRAINING_PLANS_SUCCESS,
            trainingPlans: response.data?.trainingPlanList,
            activityType
        });
    } catch (e) {
        yield put({
            type: FETCH_TRAINING_PLANS_FAIL,
            activityType
        });
    }
}

export function* fetchSelfGuidedPlan(action) {
    const { trainingPlanId, locale } = action;

    try {
        yield put({
            type: FETCH_SELF_GUIDED_PLAN_FETCHING,
            trainingPlanId
        });

        // Odd we have to use a POST instead of a GET
        const response = yield call(
            gcApi.get,
            `/trainingplan-service/trainingplan/tasks/${trainingPlanId}?localeKey=${locale}`
        );

        yield put({
            type: FETCH_SELF_GUIDED_PLAN_SUCCESS,
            trainingPlans: response.data,
            trainingPlanId
        });
    } catch (e) {
        yield put({
            type: FETCH_SELF_GUIDED_PLAN_FAIL,
            trainingPlanId
        });
    }
}

export function* fetchAllSelfGuidedPlans(action) {
    const { start, limit, locale, categories } = action;

    try {
        yield put({
            type: FETCH_ALL_SELF_GUIDED_PLAN_FETCHING
        });

        // Odd we have to use a POST instead of a GET
        const response = yield call(
            gcApi.post,
            `/trainingplan-service/trainingplan/search?start=${start}&limit=${limit}&locale=${locale}${
                categories ? '&categories=' + categories : ''
            }`,
            {},
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );

        yield put({
            type: FETCH_ALL_SELF_GUIDED_PLAN_SUCCESS,
            trainingPlans: response.data?.trainingPlanList
        });
    } catch (e) {
        yield put({
            type: FETCH_ALL_SELF_GUIDED_PLAN_FAIL
        });
    }
}

export function* fetchActivePlans(action) {
    const { limit, status } = action;

    try {
        yield put({
            type: FETCH_ACTIVE_PLANS_FETCHING
        });

        const response = yield call(
            gcApi.get,
            `/trainingplan-service/trainingplan/plans?limit=${limit}${status ? '&status=' + status : ''}`
        );

        yield put({
            type: FETCH_ACTIVE_PLANS_SUCCESS,
            trainingPlans: response.data?.trainingPlanList
        });
    } catch (e) {
        yield put({
            type: FETCH_ACTIVE_PLANS_FAIL
        });
    }
}

export const trainingPlanIntegrationSagas = [
    takeEvery(FETCH_TRAINING_PLANS, fetchTrainingPlans),
    takeEvery(FETCH_SELF_GUIDED_PLAN, fetchSelfGuidedPlan),
    takeEvery(FETCH_ALL_SELF_GUIDED_PLAN, fetchAllSelfGuidedPlans),
    takeEvery(FETCH_ACTIVE_PLANS, fetchActivePlans)
];
